import mokaRequest from '@/tools/mokaRequest';
import { LOCALES, getI18n } from '@/utils/i18n';

const i18n = getI18n();

export function getPrivacySettingByType(orgId: string, scope: string) {
  return mokaRequest('/api/outer/ats-apply/privacy-policy/get').post({
    orgId,
    scope,
    locale: i18n.language === LOCALES.EN_US ? LOCALES.EN_US : LOCALES.ZH_CN,
  });
}
